module.exports = __webpack_public_path__ + "static/media/success.d187632c.png";